module.exports = __webpack_public_path__ + "static/media/BUYNOW_Button@3x.15fd8895.png";